export class GrowerOrderItemVM {
  isSelected: boolean;
  growerOrderID: number;
  growerOrderItemId: number;
  dealerOrderItemId: number;
  growerGLN: string;
  growerGMK: number;
  shipToAccount: number;
  desiredDeliveryDate: Date;
  createTimeStamp: Date;
  updateTimeStamp: Date;
  itemID: number;
  brand: string;
  itemNumber: string;
  dealerOrderNumber: string;
  growerOrderNumber: string;
  lineNumber: string;
  itemDescription: string;
  seedSize: string;
  treatment: string;
  maturity: string;
  technology: string;
  productLine: string;
  marketingBrand: string;
  packageSize: string;
  customerPO: string;
  status: string;
  conv: number;
  seedAvailability: number;
  geu: number;
  netGEU: number;
  netBEU: number;
  sellerID: number;
  myDealerBucketQty: number;
  longShortPosition: number;
  highlightPackage: number;
  highlightTreatment: number;
  highlightTechnology: number;
  errorFlag: boolean;
  errors: error[];
  softCommitUnits: number;
  plannedUnits: number;
  shippedUnits: number;
  primaryUOM: string;
  secondaryUOM: string;
  ChangeType: string;
  cutOverDate: string;
  cutCancelOverDate: string;
  cutOverWarning: boolean;
  showCutOverWarning = false;
  stockTransferUnits: number;
  seedNonReturnable: boolean;
  eaUnits: number;
  myDealerBucket: number;
  dealerModifiableUnits: number;
  eaModifiableUnits: number;
  eaShippedUnits: number;
  eaPlannedUnits: number;
  isItemInInclusion: boolean;
  isEAModifiableChecked: boolean;
  itemGroup: string;
  isRIB: boolean;
}

export class error {
  errorItemId: string;
  errorCode: number;
  msg: string;
}

export enum errorCodes {
  negative = 1,
  highsum = 2,
  convFactWrong = 3,
  availability = 4
}
